import { render } from "./CertAwarenessCaroussel.vue?vue&type=template&id=34659b90"
import script from "./CertAwarenessCaroussel.vue?vue&type=script&lang=js"
export * from "./CertAwarenessCaroussel.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\cert-v3\\cert\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__